import React, { useState } from "react"
import loaderGIF from "../assets/images/loader.gif"
import "./useLoader.css"

export const useLoader = () => {
  const [loading, setLoading] = useState(false)

  const renderLoader = () => {
    return loading ? (
      <div className="loader-container">
        <img src={loaderGIF} alt="Loading..." />
      </div>
    ) : null
  }

  const showLoader = () => {
    setLoading(true)
  }

  const hideLoader = () => {
    setLoading(false)
  }

  return [renderLoader, showLoader, hideLoader]
}
